import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { getPodcastDataDB, logDashboadLinkViews } from '../../actions'
import { fetchDashboardLinkLogs, getDashboardSlugs } from '../../actions/DashboardActions';
// import {
//     XYChart, BarSeries, StackedBarSeries, CrossHair, XAxis, YAxis, WithTooltip,
//     LinearGradient, WrappedComponent, dateFormatter, Text
// } from '@data-ui/xy-chart';
// import theme from "@data-ui/theme/lib/chartTheme";

// import LegendOrdinal from '@vx/legend/build/legends/Ordinal';
// import scaleOrdinal from '@vx/scale/build/scales/ordinal';
import { Col, Row } from 'antd';

import Loading from '../Common/Loading';
import { dashboardBrowserOptions, dashboardOSOptions, secToDateFromPubDate, shortDomainName } from '../../lib/utils';
import { itunesByCollectionId } from '../../lib/searchItunes';

const variables = [
    { type: 'country', title: 'Unique views by Country', playTitle: 'Unique plays by Country' },
    { type: 'browser', options: dashboardBrowserOptions, title: 'Unique views by browser', playTitle: 'Unique plays by browser' },
    { type: 'os', options: dashboardOSOptions, title: 'Unique views by OS', playTitle: 'Unique plays by OS' },
    { type: 'referrer', title: 'Unique views by Referrer', playTitle: 'Unique plays by Referrer' },
    { type: 'utm_source', title: 'Unique views by utm_source', playTitle: 'Unique plays by utm_source' },
    { type: 'utm_campaign', title: 'Unique views by utm_campaign', playTitle: 'Unique plays by utm_campaign' },
    { type: 'utm_medium', title: 'Unique views by utm_medium', playTitle: 'Unique plays by utm_medium' },
];
export default class PodcastLinksPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true, linkData: {}, podcastData: {},
            // browserViews: [], browserPlays: [],
            viewsMapFin: {}, playsMapFin: {},
            viewsTotal: [], playsTotal: [],
            viewsTotalCount: 0, playsTotalCount: 0
        }
    }
    // 2023-09-18: {
    //     'views': {
    //          'total': 87
    //         'device': {ios: 1, mac: 2, windows: 1}
    //         'browser': {safari: 1, firefox: 2, chrome: 1}
    //         'country': {us: 1, uk: 2}
    //         'referrer': {'google.com': 1, 'yahoo.com': 2} /// possiblly large array
    //         'utm_source': {'google.com': 1, 'yahoo.com': 2} /// possiblly large array
    //         'utm_campaign': {'google.com': 1, 'yahoo.com': 2} /// possiblly large array
    //         'utm_medium': {'google.com': 1, 'yahoo.com': 2} /// possiblly large array
    //     }
    //     'downloads':
    //     'plays':
    // }
    componentDidMount() {
        const { userDetails } = this.props;
        const pathName = window.location.href;
        const split = pathName.split('?id=');
        const slug = (split[1] || '').replace('e-', '');
        console.dir(pathName);
        console.dir(slug);
        fetchDashboardLinkLogs(slug).then(data => {
            console.dir(data);
            // const browserViews = data['browserArr'] || [];
            // const browserPlays = data['browserPlaysArr'] || [];
            const viewsMapFin = {};
            const playsMapFin = {};
            variables.forEach(variable => {
                const varType = variable['type'];
                viewsMapFin[varType] = data['viewsMapFin'][varType];
                playsMapFin[varType] = data['playsMapFin'][varType];
            })
            console.dir(data['viewsTotal']);
            const viewsTotalCount = data['viewsTotal'].reduce((n, { y }) => n + y, 0);
            const playsTotalCount = data['playsTotal'].reduce((n, { y }) => n + y, 0);
            console.dir(viewsMapFin);
            this.setState({
                loading: false, viewsTotal: data['viewsTotal'] || [],
                playsTotal: data['playsTotal'] || [], viewsMapFin, playsMapFin,
                viewsTotalCount, playsTotalCount
            });
        })
        this._loadLinks(userDetails.uid, slug);
    }
    _loadLinks(userUID, slug) {
        getDashboardSlugs(userUID).then(prevLinks => {
            console.dir(prevLinks);
            const linkData = prevLinks[slug];
            console.dir(linkData);
            if (linkData) {
                linkData['slug'] = slug;
                const collectionId = linkData['collectionId'];
                this.fetchPodcast(collectionId);
                this.setState({ linkData });
            }
        });
    }

    fetchPodcast = async (collectionId) => {
        const queryString = itunesByCollectionId(collectionId);
        try {
            const res = await fetch(queryString);
            const result = await res.json();
            console.dir(result);
            if ('resultCount' in result && result['resultCount'] > 0) {
                if ('results' in result && result['results'].length > 0) {
                    const podcastsFin = result['results'];
                    console.dir(podcastsFin[0]);
                    this.setState({ podcastData: podcastsFin[0] });
                }
            }
        } catch (err) {
            console.error(err);
            getPodcastDataDB(collectionId).then((data) => {
                console.dir(data);
                this.setState({ podcastData: data });
            })
        }
    }
    testclick = () => {
        console.dir('click');
        logDashboadLinkViews('abc', 1438054347, 1, 2);
    }
    tickFormatFn = (tick, tickIndex) => {
        console.dir(tick);
        // return <div>{tick}</div>;
        return '';
    }
    renderTooltip = ({ event, data, datum, color, variable }) => {
        if (!variable) {
            return <div>
                <h4>{datum.x}</h4>
                <h4>{datum.y}</h4>
            </div>
        }
        // console.dir(event);
        // console.dir(data);
        // console.dir(datum);
        const arrMap = {};
        const varMap = variable; // variables.find(el => el.type == varType) || {};
        console.dir(varMap);
        const varOptions = this.mainOptions(variable);
        console.dir(varOptions);
        Object.keys(datum).forEach(el => {
            const findKey = Object.keys(varOptions).find(key => varOptions[key] == el);
            if (findKey) {
                arrMap[findKey] = datum[el];
            }
        })
        // console.dir(arrMap);
        return <div>
            <h4>{datum.x}</h4>
            {Object.keys(arrMap).map((keyVal, ind) => (
                <h4 key={ind}>
                    {(keyVal || '').toUpperCase()}&#58; {arrMap[keyVal]}
                </h4>
            ))}
        </div>
    }
    mainOptions = (variable) => {
        if (!variable) {
            return {};
        }
        const { viewsMapFin, playsMapFin } = this.state;
        if (Object.keys(variable['options'] || {}).length > 0) {
            return variable['options'];
        }
        const data = viewsMapFin[variable['type']];
        const optionsFromData = {};
        // if (variable['type'] == 'country') {
        //     console.dir(data);
        data.forEach(el => {
            Object.keys(el).forEach(key => {
                if (key != 'x' && key != 'y') {
                    optionsFromData[key] = key;
                }
            })
        })
        // console.dir(optionsFromData);
        // }
        return optionsFromData;
    }
    render() {
        const { loading, podcastData, linkData, viewsMapFin, playsMapFin, viewsTotal,
            playsTotal, viewsTotalCount, playsTotalCount } = this.state;
        if (loading) {
            return <Loading />
        }
        const fills = [`#F42A79`, '#4E7CFF', 'green', 'orange', 'brown', 'black'];
        const mockData = [
            { x: '2017-01-05', a: 1, b: 2, c: 3, y: 6 },
            { x: '2018-01-05', a: 7, b: 7, c: 7, y: 21 },
            { x: '2019-01-05', a: 5, b: 3, c: 1, y: 9 },
        ];
        console.dir(viewsMapFin);
        console.dir(playsMapFin);
        console.dir(viewsTotal);
        console.dir(linkData);
        return (
            <div>
                {podcastData.artworkUrl600 && <div className='text-center' style={{ marginBottom: '20px' }}>
                    <Row>
                        <Col span={4} offset={4}>
                            <img src={podcastData.artworkUrl600} style={{ width: '100%' }} />
                        </Col>
                        <Col span={12} style={{ paddingLeft: '2em', textAlign: 'left' }}>
                            <h1>{podcastData.uuid ? '' : podcastData.collectionName}</h1>
                            {podcastData.uuid && <p>{podcastData.collectionName}</p>}
                            <p>{shortDomainName}{linkData.uuid ? 'e/' : ''}{linkData.slug}</p>
                            <p>Created {secToDateFromPubDate(new Date(linkData.created), false)}</p>
                        </Col>
                    </Row>
                </div>
                }
                <br />
                <br />
                <Row>
                    <Col span={12}>
                        <div className='card'>
                            <h3>Unique Views (Last 30 days)</h3>
                            <h2>{viewsTotalCount}</h2>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className='card'>
                            <h3>Unique Plays (Last 30 days)</h3>
                            <h2>{playsTotalCount}</h2>
                        </div></Col>
                </Row>
                {/* <h4>Views/Downloads by Day</h4> */}
                {/* <h4 onClick={this.testclick}>Unique Views/Downloads by Day</h4> */}
                < style jsx >
                    {`
                        .card {
                            box-shadow: 0 20px 40px 0 rgba(0,11,40,.14);
                            padding: 1em;
                            margin: 2em;
                            border-radius: 12px;
                            text-align: center;
                        }
                        h3, h4 {
                            transform: translateY(30px);
                        }
                        .card h3 {
                            transform: translateY(0);
                        }
                    `}
                </style>
            </div >
        )
    }
}

PodcastLinksPage.propTypes = {
    userDetails: PropTypes.object,
    // loadingUserDetails: PropTypes.object,
    // loadingState: PropTypes.object,
    // id: PropTypes.string,
}